package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.line.RiskLineData
import com.macrofocus.eflux.network.logical.LogicalBranchId

open class RiskNetworkCapability(
    val lineData: (LogicalBranchId) -> RiskLineData
) : NetworkCapability